module.exports = __webpack_public_path__ + "img/ve.2fbcd5d4.svg";